import { useCallback, useMemo } from "react";
import { getRuntimeConfig, sessionFromBootstrap } from "@/config/runtime";
import { getPortalAdapter } from "@/api/portal-adapter";
import { usePortalData } from "@/hooks/usePortalData";

export function useSession() {
  const runtime = getRuntimeConfig();
  const adapter = getPortalAdapter();
  const bootstrapSession = sessionFromBootstrap();

  const loadSession = useCallback(
    () => (bootstrapSession ? Promise.resolve(bootstrapSession) : adapter.getSession()),
    [adapter, bootstrapSession],
  );
  const state = usePortalData(loadSession, bootstrapSession ? "session:bootstrap" : `session:${runtime.mode}`);

  return useMemo(
    () => ({
      ...state,
      mode: runtime.mode,
      usesPortalLoginPage: runtime.usesPortalLoginPage,
    }),
    [runtime.mode, runtime.usesPortalLoginPage, state],
  );
}
